declare global {
  interface Window {
    grecaptcha: any
  }
}
const handleLoaded = (action: string) => {
  window['grecaptcha'].ready(() => {
    window['grecaptcha']
      .execute(`${import.meta.env.REACT_APP_SiteKey}`, { action: action })
      .then((token: string) => {
        // console.log(token)
      })
  })
}
export const invokeCaptcha = (action: string) => {
  const script = document.createElement('script')
  script.src = `${import.meta.env.REACT_APP_ReCaptchaAPI}${import.meta.env.REACT_APP_SiteKey}`
  script.addEventListener('load', () => handleLoaded(action))
  document.body.appendChild(script)
}
